<div class="row">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header">
        <div class="filter-wrapper field_space">
          <div class="form-group col-12-div">
            <div class="form-group col-4-div">
              <label>Date</label>
              <input class="form-control border-primary" type="date" placeholder="Date" name="from_date"
                [(ngModel)]="from_date" (ngModelChange)="dataList = []">
            </div>
            <div class="form-group col-4-div">
              <label>Category</label>
              <select class="form-control border-primary" name="category" [(ngModel)]="category" (ngModelChange)="dataList = []">
                <option value="">select</option>
                <option *ngFor="let cat of categories" [value]="cat">{{cat}}</option>
              </select>
            </div>
            <div class="form-group">
              <button type="button" style="margin-top: 30px;" class="btn btn-primary btn-fw top-btn-head" (click)="getList()">Load</button>
            </div>
          </div>
        </div>
        <h4 class="card-title">
          <div class="d-flex bd-highlight">
            <div class="p-2 flex-grow-1 bd-highlight">Media Management</div>
            <div class="form-group col-1  text-center pt-4 mt-2 ml-4" style="margin-left: auto !important;" *ngIf="permissionsService.checkPermission('add_media')">
              <a title="Add Media" routerLink="/add-media"> <i class="fa fa-plus-circle" style="font-size: 35px;cursor: pointer; color: #fba339;" aria-hidden="true"></i></a>
            </div>
          </div>
        </h4>
        <div class="table-responsive" *ngIf="dataList && dataList.data && dataList.data.length">
          <table class="table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Category</th>
                <th>Date</th>
                <th>Media Type</th>
                <th>Preview</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of dataList?.data; let i = index">
                <td>
                  <span *ngIf="page == 1">{{i+1}}</span>
                  <span *ngIf="page > 1">{{((page - 1) * 20) + (i+1)}}</span>
                </td>
                <td>{{data?.category}}</td>
                <td>{{data?.date | date : 'dd-MM-yyyy'}}</td>
                <td>
                  <i class="fa {{getMediaTypeIcon(data?.media_type)}}" aria-hidden="true"></i>
                  <span>{{data?.media_type === 'video' ? 'Video' : 'Image'}}</span>
                </td>
                <td>
                  <div class="media-preview">
                    <img *ngIf="data?.media_type === 'image'" 
                      [src]="data?.thumbnail_url || data?.media_url" 
                      [alt]="data?.category" 
                      style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                      (click)="viewMedia(data?.media_url)"
                      title="Click to view">
                    <div *ngIf="data?.media_type === 'video'" 
                      style="position: relative; width: 50px; height: 50px; cursor: pointer;"
                      (click)="viewMedia(data?.media_url)"
                      title="Click to view video">
                      <img [src]="data?.thumbnail_url" 
                        [alt]="data?.category" 
                        style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;">
                      <i class="fa fa-play-circle" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; font-size: 20px; text-shadow: 1px 1px 2px rgba(0,0,0,0.8);"></i>
                    </div>
                  </div>
                </td>
                <td class="fixed-side">
                  <a title="Edit"  (click)="editMedia(data)" class="mr-3">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                  <a title="Delete" *ngIf="permissionsService.checkPermission('delete_media')" (click)="deleteMedia(data)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="p-12" *ngIf="dataList && dataList.data && !dataList.data.length">
          <span class="ng-star-inserted no_data">No Data found.</span>
        </div>
      </div>
    </div>
  </div>
</div>
